import { Plant } from './plant';
import { Field } from './field';
import { Commodity } from './commodity';
import { Variety } from './variety';
import { Batch } from './batch';
import { SupplyChainDestination } from './supplyChainDestination';
import { TenantGeneralData } from './tenantGeneralData';
import { ChecksConfig } from './checks/CropsConfig';
import { Parcel } from './parcel';
import { CommodityCountryFields } from './commodityCountryFields';

export class Crop extends TenantGeneralData {
  year: number;
  commodity: Commodity;
  field: Field;
  variety: Variety;
  size: number;
  isPrimary: boolean;
  coverCrop: boolean;
  note: string;
  hasSubUnits?: boolean;
  cropSubUnitTotalSize?: number;
  closedDate: string;
  pestManagementConfiguration?: string;
  pestManagementCountry?: string;
  pestManagementRegion?: string;
  phenologicalPhases?: { id: number };

  /* ROOTSTOCK */
  rootstock?: string;
  plantsCount?: number;
  plantsX?: number;
  plantsY?: number;
  plantsUnit?: string;
  plantsPlantingDate?: Date;
  plantsCuttingDate?: Date;
  plantsHarvestingDate?: Date;
  plantsUpdateDate?: Date;
  plantsNote?: string;

  plant?: Plant;
  plantId?: number;

  /* TRANSIENTS */
  commodityName?: string;
  varietyName?: string;

  batch: Batch = null;
  targetYield: number = null;
  targetYieldUnit: string = null;
  isClosed: boolean;
  uuid?: string;
  multiYear?: boolean;
  supplyChainDestinations?: SupplyChainDestination[];
  intendedUseId?: string;
  qualityId?: string;
  useId?: string;

  // Configuration Obj for checks module
  checksConfig?: ChecksConfig;
  parcel?: Parcel;
  commodityCountryFields?: CommodityCountryFields;
  season?: string;
  isOgm?: boolean;
  wasManuallySet?: boolean;

  constructor() {
    super();
    this.id = null;
    this.year = null;
    this.commodity = null;
    this.field = null;
    this.size = null;
    this.variety = null;
    this.isPrimary = true;
    this.coverCrop = false;
    this.closedDate = null;
    this.intendedUseId = null;
    this.pestManagementConfiguration = null;
    this.pestManagementCountry = null;
    this.pestManagementRegion = null;

    /* ROOTSTOCK */
    this.rootstock = null;
    this.plantsCount = null;
    this.plantsX = null;
    this.plantsY = null;
    this.plantsUnit = null;
    this.plantsPlantingDate = null;
    this.plantsCuttingDate = null;
    this.plantsHarvestingDate = null;
    this.plantsUpdateDate = null;
    this.plantsNote = null;

    this.plant = new Plant();
    this.plantId = null;

    /* TRANSIENTS */
    this.commodityName = null;
    this.varietyName = null;

    this.dateCreated = null;
    this.lastUpdated = null;
    this.note = null;
    this.batch = null;
    this.targetYield = null;
    this.targetYieldUnit = null;
    this.cropSubUnitTotalSize = null;
    this.hasSubUnits = null;
    this.isClosed = false;
    this.uuid = null;
    this.multiYear = false;
    this.supplyChainDestinations = null;

    this.checksConfig = null;
    this.parcel = null;
    this.commodityCountryFields = null;
    this.season = null;
    this.isOgm = false;
    this.qualityId = null;
    this.useId = null;
    this.wasManuallySet = null;
    this.phenologicalPhases = null;
  }
}
